// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import FinanceAccount from "./finance-account.js"
import FinanceDimensionValue from "./finance-dimension-value.js"

const modelClassData = {
  "attributes": {
    "hourly_wage": {
      "column": null,
      "name": "hourly_wage",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "internal_price": {
      "column": null,
      "name": "internal_price",
      "selected_by_default": null,
      "translated": null
    },
    "project_price": {
      "column": null,
      "name": "project_price",
      "selected_by_default": null,
      "translated": null
    },
    "valid_from": {
      "column": {
        "default": null,
        "name": "valid_from",
        "null": true,
        "type": "date"
      },
      "name": "valid_from",
      "selected_by_default": null,
      "translated": null
    },
    "valid_to": {
      "column": {
        "default": null,
        "name": "valid_to",
        "null": true,
        "type": "date"
      },
      "name": "valid_to",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "EmployeePrice",
  "collectionKey": "employee_prices",
  "collectionName": "employee_prices",
  "i18nKey": "employee_price",
  "camelizedLower": "employeePrice",
  "name": "EmployeePrice",
  "nameDasherized": "employee-price",
  "pluralName": "employee_prices",
  "ransackable_associations": [
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "bearer_id",
      "name": "bearer",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "bearer_id",
      "column": {
        "default": null,
        "name": "bearer_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "finance_account_id",
      "column": {
        "default": null,
        "name": "finance_account_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "hourly_wage_cents",
      "column": {
        "default": 0,
        "name": "hourly_wage_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "hourly_wage_currency",
      "column": {
        "default": "DKK",
        "name": "hourly_wage_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "internal_price_cents",
      "column": {
        "default": 0,
        "name": "internal_price_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "internal_price_currency",
      "column": {
        "default": "DKK",
        "name": "internal_price_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_bearer_id",
      "column": {
        "default": null,
        "name": "old_bearer_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "project_price_cents",
      "column": {
        "default": 0,
        "name": "project_price_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "project_price_currency",
      "column": {
        "default": "DKK",
        "name": "project_price_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "valid_from",
      "column": {
        "default": null,
        "name": "valid_from",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "valid_to",
      "column": {
        "default": null,
        "name": "valid_to",
        "null": true,
        "type": "date"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "bearer_id",
      "name": "bearer",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    }
  ],
  "paramKey": "employee_price",
  "primaryKey": "id"
}

/** Frontend model for EmployeePrice. */
export default class EmployeePrice extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  hourlyWage() {
    return this.readAttributeUnderscore("hourly_wage")
  }

  /** @returns {boolean} */
  hasHourlyWage() {
    const value = this.hourlyWage()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  internalPrice() {
    return this.readAttributeUnderscore("internal_price")
  }

  /** @returns {boolean} */
  hasInternalPrice() {
    const value = this.internalPrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  projectPrice() {
    return this.readAttributeUnderscore("project_price")
  }

  /** @returns {boolean} */
  hasProjectPrice() {
    const value = this.projectPrice()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  validFrom() {
    return this.readAttributeUnderscore("valid_from")
  }

  /** @returns {boolean} */
  hasValidFrom() {
    const value = this.validFrom()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  validTo() {
    return this.readAttributeUnderscore("valid_to")
  }

  /** @returns {boolean} */
  hasValidTo() {
    const value = this.validTo()

    return this._isPresent(value)
  }

  /** @returns {import("./finance-dimension-value.js").default | null} */
  bearer() {
    return this._readBelongsToReflection({modelClass: FinanceDimensionValue, reflectionName: "bearer"})
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  loadBearer() {
    if (!("bearerId" in this)) throw new Error("Foreign key method wasn't defined: bearerId")

    const id = this.bearerId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bearer",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  ensureBearerLoaded() {
    return this.ensureAssociationLoaded("bearer")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./finance-account.js").default | null} */
  financeAccount() {
    return this._readBelongsToReflection({modelClass: FinanceAccount, reflectionName: "finance_account"})
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  loadFinanceAccount() {
    if (!("financeAccountId" in this)) throw new Error("Foreign key method wasn't defined: financeAccountId")

    const id = this.financeAccountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_account",
        model: this,
        modelClass: FinanceAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  ensureFinanceAccountLoaded() {
    return this.ensureAssociationLoaded("finance_account")
  }
}
